export const BASE_URL = window.BASE_URL;